import { Button } from '@mui/material'
import React, { useCallback } from 'react'
import { NavigateFunction, useNavigate } from 'react-router-dom'

import { useApp } from '@/hooks'
import { t } from '@/i18n'
import { signInPath } from '@/utils/index'
import AdditionalFunctions from './menus/AdditionalFunctions'

const AppFooter: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const { onSignOut } = useApp()

  const _onSignOut = useCallback(() => {
    onSignOut(() => {
      navigate(signInPath, { replace: true })
    })
  }, [navigate, onSignOut])

  return (
    <footer>
      <div className="container">
        <div className="data-wrap">
          <div className="btn-box">
            <div className="btn-item">
              <Button
                onClick={_onSignOut}
                startIcon={<span className="icon-logout" />}
              >
                {t('log_out')}
              </Button>
            </div>
          </div>
          <div className="btn-box">
            <AdditionalFunctions />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default AppFooter
